import { AppBar, Avatar, Box, Button, Container, IconButton, Toolbar, Tooltip, Typography } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { Link as RouterLink } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import type { ReactNode } from "react";

export function AppLayout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth();

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "background.default" }}>
      <AppBar position="static" color="primary">
        <Toolbar>
          <Box
            component={RouterLink}
            to="/"
            aria-label="Go to dashboard"
            sx={{
              display: "flex", alignItems: "center", gap: 1.5, flexGrow: 1,
              color: "inherit", textDecoration: "none",
            }}
          >
            <Box component="img" src="/logo-white.png" alt="Freedom Power" sx={{ height: 26 }} />
            <Typography variant="h6">Approvals Dashboard</Typography>
          </Box>
          {user && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              {user.avatar_url && <Avatar src={user.avatar_url} sx={{ width: 32, height: 32 }} />}
              <Typography variant="body2">{user.email}</Typography>
              {user.super_admin && (
                <Tooltip title="Manage users">
                  <IconButton
                    color="inherit"
                    size="small"
                    component={RouterLink}
                    to="/settings/users"
                    aria-label="Manage users"
                  >
                    <SettingsIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              )}
              <Button color="inherit" size="small" onClick={logout}>
                Sign out
              </Button>
            </Box>
          )}
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        {children}
      </Container>
    </Box>
  );
}
